'use client';

import { type ReactNode } from 'react';
import useMap from '@/hooks/useMap';
import { MAP_SIZE } from '@/constants/mapConstants';

export function SearchResultsContainer({ children }: { children?: ReactNode }) {
  const { mapView } = useMap();
  const maxWidth = mapView === MAP_SIZE.MEDIUM ? '' : 'sm:max-w-screen-2xl';

  return (
    <div className="flex flex-col items-center">
      <div
        className={`flex w-full justify-center gap-x-5 ${maxWidth} lg:gap-x-6 ${
          mapView === MAP_SIZE.MEDIUM ? 'xl:pl-6' : 'xl:px-6'
        }`}
      >
        {children}
      </div>
    </div>
  );
}
